<template>
    <ManagementListPage title="QGC" subtitle="Quadro Geral de Credores da Recuperação Judicial."
        :result-text="`${dataList.count} credor${dataList.count === 1 ? '' : 'es'} encontrado${dataList.count === 1 ? '' : 's'}`"
        :breadcrumbs="[{ text: 'Homepage', to: '/home', exact: true }, { text: 'QGC', disabled: true }]">
        <template v-slot:actions>
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-btn v-if="$check(user, ['usercreditors.create'])" v-on="on" id="btnNew" type="button"
                                    color="primary" elevation="0" to="/qgc/novo">Incluir
                                </v-btn>
                            </template>
                            <span>Adicionar</span>
                        </v-tooltip>
        </template>
        <template v-slot:navigation>
                <v-tabs v-model="selectedTabIndex" class="management-list-tabs" @change="load">
                    <v-tab v-for="tab in dataset.versionTabs" :key="tab.id" :value="tab.id">
                        {{ tab.label }}
                    </v-tab>
                </v-tabs>
        </template>
        <template v-slot:filters>
            <v-form @submit.prevent="applyFilters">
                <div class="op-filter-toolbar">
                    <v-text-field v-model="quickSearch" dense outlined hide-details clearable
                        prepend-inner-icon="mdi-magnify" placeholder="Buscar por nome ou CPF/CNPJ"
                        @keyup.enter="applyFilters" />
                    <v-btn outlined color="primary" @click="showFilters = !showFilters">
                        <v-icon left small>mdi-tune-variant</v-icon>
                        Filtros
                        <span v-if="activeFilterCount" class="op-filter-count">{{ activeFilterCount }}</span>
                        <v-icon right small>{{ showFilters ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                    <v-btn id="btnFilter" type="submit" color="primary" elevation="0">
                        <v-icon left small>mdi-magnify</v-icon>
                        Buscar
                    </v-btn>
                </div>

                <v-expand-transition>
                    <div v-if="showFilters" class="op-filter-panel mt-3 pt-3">
                        <div class="op-filter-panel-head">
                            <div>
                                <strong>Filtros avançados</strong>
                                <span>Refine os credores exibidos na listagem.</span>
                            </div>
                        </div>
                        <v-row dense class="op-filter-grid">
                            <v-col cols="12" md="4">
                                <div class="op-field">
                                    <label>Nome</label>
                                    <v-text-field v-model="dataList.filter.name" placeholder="Informe o nome"
                                        dense outlined hide-details clearable />
                                </div>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div class="op-field">
                                    <label>CPF/CNPJ</label>
                                    <v-text-field v-model="dataList.filter.registration" placeholder="Informe o CPF ou CNPJ"
                                        dense outlined hide-details clearable />
                                </div>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div class="op-field">
                                    <label>Valor igual ou maior</label>
                                    <v-currency-field id="amount" v-model="dataList.filter.amount"
                                        placeholder="R$ 0,00" dense outlined hide-details :allowNegative="false" />
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-expand-transition>

                <div v-if="showFilters" class="op-filter-footer">
                    <span>{{ activeFilterCount ? `${activeFilterCount} filtro(s) ativo(s)` : 'Nenhum filtro adicional aplicado' }}</span>
                    <v-btn v-if="hasFilters()" text small color="primary" @click="clearFilters">Limpar filtros</v-btn>
                </div>
            </v-form>
        </template>
        <template v-slot:tableActions>
                    <span></span>
                        <div class="icon-toolbar">
                            <!-- Botão Removidos (só na aba V3) -->
                            <v-tooltip bottom v-if="currentVersion === 3">
                                <template #activator="{ on }">
                                    <v-badge :content="deletedCount" :value="deletedCount > 0" color="error" overlap
                                        offset-x="8" offset-y="8">
                                        <v-icon v-on="on" @click="openDeletedModal()" size="large" color="error">
                                            mdi-delete-clock-outline
                                        </v-icon>
                                    </v-badge>
                                </template>
                                <span>Ver registros removidos</span>
                            </v-tooltip>

                            <!-- Ícone de CSV -->
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-icon :disabled="!$check(user, ['usercreditorsadjusted.create.csv'])" v-on="on"
                                        @click="generateCSV()" size="x-large">
                                        mdi-microsoft-excel
                                    </v-icon>
                                </template>
                                <span>Exportar dados para CSV</span>
                            </v-tooltip>

                            <!-- Habilitar a estrutura abaixo para gerar um novo conjunto de pdf´s 
                                com os dados atuais da tabela do qgv v3 -->

                            <!-- <v-tooltip bottom v-if="selectedTabIndex === 2">
                                <template #activator="{ on }">
                                    <v-icon :disabled="!$check(user, ['usercreditorsadjusted.create.pdflist']) || isGenerating"
                                        v-on="on" @click="generatePdf()" size="large">
                                        mdi-file-pdf-box
                                    </v-icon>
                                </template>
                                <span>Gerar lista de credores PDF</span>
                            </v-tooltip>

                            <v-tooltip bottom v-if="status === 'processing' && selectedTabIndex === 2">
                                <template #activator="{ on }">
                                    <v-chip color="blue" text-color="white" small v-on="on">
                                        <v-progress-circular indeterminate size="14" width="2" class="mr-2" color="white" />
                                        {{ progressText || 'Iniciando...' }}
                                    </v-chip>
                                </template>
                                <span>Gerando PDFs: {{ progressText || 'Aguardando...' }}</span>
                            </v-tooltip>

                            <v-tooltip bottom v-if="statusText && status !== 'processing' && selectedTabIndex === 2">
                                <template #activator="{ on }">
                                    <v-chip :color="statusColor" text-color="white" small v-on="on">
                                        {{ statusText }}
                                    </v-chip>
                                </template>
                                <span>Status da geração: {{ statusText }}</span>
                            </v-tooltip> -->
                        </div>
        </template>
        <template v-slot:table>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum credor foi encontrado" loading-text="Carregando dados..."
                            class="management-list-table app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.name`]="{ item }">
                                <div :class="{ 'excluded-record': item.excluded_by }">
                                    <v-avatar :size="30"
                                        :color="item.is_important === 1 ? '#FFECB3' : 'grey lighten-2'">
                                        <span>{{ item.name.split(' ').map(word => word[0]).join('').slice(0,
                                            2).toUpperCase() }}</span>
                                    </v-avatar>
                                    <v-icon v-if="item.exclude_requested_at && !item.excluded_by" color="red"
                                        class="ml-2" small>
                                        mdi-close-circle
                                    </v-icon>
                                    <span class="ml-4 list-item-title">
                                        {{ item.name.length > 15 ? item.name.slice(0, 20) + '...' : item.name }}
                                    </span>
                                </div>
                            </template>

                             <template v-slot:[`item.version`]="{ item }">
                                <v-chip small class="text-uppercase font-weight-bold text-caption"
                                    label :color="getPhaseChipColor(item.version)" text-color="white">
                                    {{ item.version ? getAnalysisPhaseName(item.version) : 'N/A' }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.registration`]="{ item }">
                                {{ formatCpfCnpj(item.registration) }}
                            </template>

                            <template v-slot:[`item.type`]="{ item }">
                                <v-chip label text-color="primary">
                                    {{ getTypeName(item.type) }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.amount`]="{ item }">
                                R$ {{ item.amount | currency }}
                            </template>

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <div class="d-flex align-center">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-on="on"
                                                :disabled="!$check(user, ['usercreditors.find'])"
                                                @click="viewItem(item)" size="large" class="me-2">
                                                mdi-eye-outline
                                            </v-icon>
                                        </template>
                                        <span>Visualizar credor</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-on="on"
                                                v-if="currentVersion === 3"
                                                :disabled="!$check(user, ['usercreditors.update'])"
                                                @click="editItem(item)" size="large" class="me-2">
                                                mdi-pencil-outline
                                            </v-icon>
                                        </template>
                                        <span>Editar credor</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-on="on"
                                                v-if="currentVersion === 3"
                                                :disabled="!$check(user, ['usercreditors.delete'])"
                                                @click="deleteItem(item)" size="large" class="me-2">
                                                mdi-delete-outline
                                            </v-icon>
                                        </template>
                                        <span>Excluir credor</span>
                                    </v-tooltip>
                                </div>
                            </template>
                        </v-data-table>
        </template>

        <!-- Modal de Registros Removidos -->
        <v-dialog v-model="deletedModal.show" max-width="1000" scrollable>
            <v-card>
                <v-card-title class="d-flex align-center">
                    <v-icon left color="error">mdi-delete-clock-outline</v-icon>
                    Registros Removidos do QGC Consolidado
                    <v-spacer />
                    <v-btn icon @click="deletedModal.show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider />

                <v-card-text class="pt-4">
                    <!-- Filtro por CPF/CNPJ -->
                    <v-row dense class="mb-3">
                        <v-col cols="12" sm="6">
                            <v-text-field dense label="Buscar por CPF/CNPJ/NOME" v-model="deletedModal.filter.registration"
                                outlined hide-details clearable @keyup.enter="loadDeleted()" @click:clear="clearDeletedFilter()">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" class="d-flex align-center">
                            <v-btn small color="primary" @click="loadDeleted()">
                                <v-icon left small>mdi-magnify</v-icon>
                                Buscar
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-data-table
                        :headers="deletedModal.headers"
                        :items="deletedModal.data"
                        :server-items-length="deletedModal.count"
                        :loading="deletedModal.loading"
                        :options.sync="deletedModal.options"
                        @update:page="deletedPageChanged"
                        @update:items-per-page="deletedPageSizeChanged"
                        :disable-sort="true"
                        no-data-text="Nenhum registro removido encontrado"
                        loading-text="Carregando..."
                        class="app-table"
                        :footer-props="{ itemsPerPageText: 'Itens:', itemsPerPageOptions: [5, 10, 20] }"
                    >
                        <template v-slot:[`item.registration`]="{ item }">
                            {{ item.registration ? formatCpfCnpj(item.registration) : '—' }}
                        </template>

                        <template v-slot:[`item.old_data`]="{ item }">
                            <span v-if="item.old_data">
                                {{ item.old_data.name ? (item.old_data.name.length > 25 ? item.old_data.name.slice(0, 25) + '...' : item.old_data.name) : '—' }}
                            </span>
                        </template>

                        <template v-slot:[`item.type`]="{ item }">
                            <v-chip small label text-color="primary" v-if="item.old_data">
                                {{ getTypeName(item.old_data.type) }}
                            </v-chip>
                        </template>

                        <template v-slot:[`item.amount`]="{ item }">
                            <span v-if="item.old_data">
                                R$ {{ item.old_data.amount | currency }}
                            </span>
                        </template>

                        <template v-slot:[`item.reason`]="{ item }">
                            <v-tooltip bottom v-if="item.reason" max-width="300">
                                <template #activator="{ on }">
                                    <span v-on="on" class="caption">
                                        {{ item.reason.length > 20 ? item.reason.slice(0, 20) + '...' : item.reason }}
                                    </span>
                                </template>
                                <span>{{ item.reason }}</span>
                            </v-tooltip>
                            <span v-else class="caption grey--text">—</span>
                        </template>

                        <template v-slot:[`item.admin_id`]="{ item }">
                            <span class="caption">{{ item.admin_id ? 'Admin #' + item.admin_id : '—' }}</span>
                        </template>

                        <template v-slot:[`item.created_at`]="{ item }">
                            <span class="caption">{{ formatDate(item.created_at) }}</span>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="deletedModal.show = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog de confirmação de exclusão com motivo -->
        <v-dialog v-model="deleteDialog.show" max-width="500" persistent>
            <v-card>
                <v-card-title>
                    <v-icon left color="error">mdi-delete-alert</v-icon>
                    Excluir Credor
                </v-card-title>
                <v-card-text>
                    <p class="mb-4">
                        Tem certeza que deseja excluir o credor
                        <strong>{{ deleteDialog.item ? deleteDialog.item.name : '' }}</strong>?
                    </p>
                    <p class="caption grey--text mb-3">
                        Esta ação é irreversível. O registro será removido do QGC e ficará disponível apenas no histórico de removidos.
                    </p>
                    <v-textarea v-model="deleteDialog.reason" label="Motivo da exclusão *" outlined dense
                        rows="3" :rules="[v => !!v && !!v.trim() || 'Informe o motivo da exclusão']"
                        placeholder="Descreva o motivo pelo qual este credor está sendo excluído..."
                        counter="500" maxlength="500">
                    </v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="deleteDialog.show = false" :disabled="deleteDialog.loading">Cancelar</v-btn>
                    <v-btn color="error" @click="confirmDelete()" :loading="deleteDialog.loading"
                        :disabled="!deleteDialog.reason || !deleteDialog.reason.trim()">
                        <v-icon left>mdi-delete</v-icon>
                        Excluir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </ManagementListPage>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';
import { cpf, cnpj } from 'cpf-cnpj-validator'
import creditorTypes from "@/common/data/creditor-types.data"
import qgcVersions from '@/common/data/qgc-versions.data.js';

import userTypes from "@/common/data/user-types.data";

Vue.use(VueLodash)

export default {
    name: "UserList",

    data: () => ({
        user: null,
        selectedTabIndex: 2,
        quickSearch: "",
        showFilters: false,
        dataset: {
            userTypes: userTypes,
            data: {},
            creditorTypes: creditorTypes,
            versionTabs: qgcVersions,
            analysisPhaseTypes: [{ id: 1, name: "Fase 1" }, { id: 2, name: "Fase 2", }, { id: 3, name: "Fase 3" }],
        },
        isGenerating: false,
        jobId: null,
        pollingInterval: null,
        progressText: '',
        generatedFiles: [],
        status: 'idle',
        dataList: {
            filter: {
                name: "",
                registration: "",
                amount: "",
                version: "",
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "CPF/CNPJ", value: "registration" },
                { text: "Classe", value: "type" },
                { text: "Valor", value: "amount" },
                { text: "Fase", value: "version" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
        deletedModal: {
            show: false,
            loading: false,
            data: [],
            count: 0,
            filter: {
                registration: '',
            },
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            headers: [
                { text: "CPF/CNPJ", value: "registration", width: "140px" },
                { text: "Nome", value: "old_data" },
                { text: "Classe", value: "type", width: "120px" },
                { text: "Valor", value: "amount", width: "130px" },
                { text: "Motivo", value: "reason" },
                { text: "Admin", value: "admin_id", width: "100px" },
                { text: "Removido em", value: "created_at", width: "140px" },
            ],
        },
        deletedCount: 0,
        // Dialog de exclusão com motivo
        deleteDialog: {
            show: false,
            loading: false,
            item: null,
            reason: '',
        },
    }),

    computed: {
        activeFilterCount() {
            return ['name', 'registration', 'amount']
                .filter(key => this.dataList.filter[key] !== "" && this.dataList.filter[key] !== null).length;
        },

        currentVersion() {
            const currentTab = this.dataset.versionTabs[this.selectedTabIndex];
            return currentTab ? Number(currentTab.id) : undefined;
        },

        // statusText() {
        //     switch (this.status) {
        //         case 'processing': return 'Em andamento';
        //         case 'completed': return 'Concluído';
        //         case 'failed': return 'Falhou';
        //         default: return 'Parado';
        //     }
        // },

        // statusColor() {
        //     switch (this.status) {
        //         case 'processing': return 'orange';
        //         case 'completed': return 'green';
        //         case 'failed': return 'red';
        //         default: return 'grey';
        //     }
        // },
    },

    created() {
        this.load();
        this.loadDeletedCount();
    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.itemsPerPage = size;
            this.load(true);
        },

        hasFilters() {
            return this.activeFilterCount > 0 || !!this.quickSearch;
        },

        clearFilters() {
            this.quickSearch = "";
            Object.keys(this.dataList.filter).forEach(key => {
                this.dataList.filter[key] = "";
            });
            this.applyFilters();
        },

        applyFilters() {
            this.dataList.options.page = 1;
            this.load();
        },

        clearNameSearch() {
            this.dataList.filter.name = "";
            this.load();
        },

        clearCpfCnpjSearch() {
            this.dataList.filter.registration = "";
            this.load();
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        getTypeName(typeId) {
            const type = this.dataset.creditorTypes.find(s => s.id === typeId);
            return type ? type.name : 'N/A';
        },

        onImportDone(result) {
            this.load();
        },

        formatCpfCnpj(value) {
            if (!value) return '—';
            return value.length == 14 ? cnpj.format(value) : cpf.format(value);
        },

        formatDate(dateStr) {
            if (!dateStr) return '';
            var d = new Date(dateStr);
            return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
        },

        async load() {
            this.user = this.$root.user.data || this.$root.user;

            const normalizedVersion = this.dataset.versionTabs[this.selectedTabIndex].id;

            const quickSearch = String(this.quickSearch || '').trim();
            const quickSearchDigits = quickSearch.replace(/\D/g, '');
            const quickSearchIsRegistration = quickSearch
                && /^[\d.\-/\s]+$/.test(quickSearch)
                && quickSearchDigits.length >= 11;

            const registration = quickSearchIsRegistration
                ? quickSearch
                : this.dataList.filter.registration;
            const cleanRegistration = registration
                ? registration.replace(/\D/g, '')
                : undefined;

            const search = {
                name: quickSearch && !quickSearchIsRegistration
                    ? quickSearch
                    : this.dataList.filter.name || undefined,
                registration: cleanRegistration || undefined,
                amount: this.dataList.filter.amount || undefined,
                version: normalizedVersion !== undefined ? Number(normalizedVersion) : undefined,
            };

            const params = {
                page: this.dataList.options.page,
                limit: this.dataList.options.itemsPerPage,
                search: JSON.stringify(search)
            };

            this.dataList.loading = true;

            try {
                const result = await axios.get('/api/admin/users-creditors-claim', { params });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                })
            } finally {
                this.dataList.loading = false;
            }
        },

        async loadDeletedCount() {
            try {
                var result = await axios.get('/api/admin/users-creditors-claim/deleted', {
                    params: { page: 1, limit: 1 }
                });
                this.deletedCount = result.data.content.paging.total || 0;
            } catch (e) {
                this.deletedCount = 0;
            }
        },

        async openDeletedModal() {
            this.deletedModal.show = true;
            this.deletedModal.options.page = 1;
            this.deletedModal.filter.registration = '';
            await this.loadDeleted();
        },

        async loadDeleted() {
            this.deletedModal.loading = true;

            var cleanReg = this.deletedModal.filter.registration
                ? this.deletedModal.filter.registration.replace(/\D/g, '')
                : undefined;

            var params = {
                page: this.deletedModal.options.page,
                limit: this.deletedModal.options.itemsPerPage,
                search: JSON.stringify({
                    registration: cleanReg || undefined,
                }),
            };

            try {
                var result = await axios.get('/api/admin/users-creditors-claim/deleted', { params });
                this.deletedModal.data = result.data.content.data;
                this.deletedModal.count = result.data.content.paging.total;
                this.deletedCount = result.data.content.paging.total;
            } catch (error) {
                this.deletedModal.data = [];
                this.deletedModal.count = 0;
            } finally {
                this.deletedModal.loading = false;
            }
        },

        clearDeletedFilter() {
            this.deletedModal.filter.registration = '';
            this.loadDeleted();
        },

        deletedPageChanged(page) {
            this.deletedModal.options.page = page;
            this.loadDeleted();
        },

        deletedPageSizeChanged(size) {
            this.deletedModal.options.itemsPerPage = size;
            this.deletedModal.options.page = 1;
            this.loadDeleted();
        },

        deleteItem(item) {
            this.deleteDialog.item = item;
            this.deleteDialog.reason = '';
            this.deleteDialog.show = true;
        },

        async confirmDelete() {
            if (!this.deleteDialog.reason || !this.deleteDialog.reason.trim()) return;

            this.deleteDialog.loading = true;

            try {
                await axios.delete('/api/admin/users-creditors-claim/' + this.deleteDialog.item.id, {
                    data: { reason: this.deleteDialog.reason.trim() }
                });

                this.$dialog.notify.info("Credor excluído com sucesso!", { position: "top-right", timeout: 3000 });

                this.deleteDialog.show = false;
                this.load();
                this.loadDeletedCount();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            } finally {
                this.deleteDialog.loading = false;
            }
        },

        getAnalysisPhaseName(phaseId) {
            if (phaseId === null || phaseId === undefined || !this.dataset.analysisPhaseTypes) return 'N/A';
            const phase = this.dataset.analysisPhaseTypes.find(p => p.id === phaseId);
            return phase ? phase.name : 'N/A';
        },

        getPhaseChipColor(phaseId) {
            if (phaseId === 1) return '#7E55AB';
            if (phaseId === 2) return '#29B6F6';
            if (phaseId === 3) return '#009688';
            return 'grey';
        },

        viewItem(item) {
            sessionStorage.setItem('qgcDetailContext', JSON.stringify({
                id: item.id,
                mode: 'view'
            }));
            this.$router.push('/qgc/detalhes');
        },

        editItem(item) {
            sessionStorage.setItem('qgcDetailContext', JSON.stringify({
                id: item.id,
                mode: 'edit'
            }));
            this.$router.push('/qgc/detalhes');
        },

        async generateCSV() {
            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja exportar os dados para CSV?',
                title: 'Exportar dados',
                actions: { false: 'Cancelar', true: 'Exportar' }
            })

            if (!proceedAction) return;

            var limit = 1000000;
            var currentTab = this.dataset.versionTabs[this.selectedTabIndex];
            var versionId = currentTab ? Number(currentTab.id) : undefined;

            const result = await axios.get('/api/admin/users-creditors-claim', {
                params: {
                    limit: limit,
                    search: JSON.stringify({
                        version: versionId,
                    })
                }
            });

            if (result.data.content.data.length == 0) {
                this.$dialog.notify.error("Sem dados para gerar arquivo CSV!", { position: "top-right", timeout: 2000 });
                return;
            }

            const newData = result.data.content.data.map(obj => ({
                "NOME CREDOR": obj.name,
                "CPF/CNPJ": this.formatCpfCnpj(obj.registration),
                "E-MAIL": obj.email,
                "VALOR": obj.amount ? obj.amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : "N/A",
                "CLASSE": this.getTypeName(obj.type),
                "FASE": this.getAnalysisPhaseName(obj.version),
                "CRIADO EM": obj.created_at,
            }));

            try {
                const header = Object.keys(newData[0]);
                const csvContent = [header.join(';')];

                newData.forEach(item => {
                    const row = header.map(key => {
                        const value = item[key];
                        return typeof value === 'object' && value !== null ? value.join(';') : value;
                    }).join(';');
                    csvContent.push(row);
                });

                const csv = csvContent.join('\r\n');
                const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute('href', url);
                link.setAttribute('download', 'QGC_Fase_' + (versionId || '') + '.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.$dialog.notify.info("Arquivo CSV gerado com sucesso!", { position: "top-right", timeout: 2000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            }
        },

        // FUNÇÕES PARA GERAR OS PDFS DO SITE
        // async generatePdf() {
        //     const proceedAction = await this.$dialog.confirm({
        //         text: 'Deseja gerar uma nova lista de credores em PDF?',
        //         title: 'Gerar nova lista',
        //         actions: { false: 'Cancelar', true: 'Gerar' }
        //     })

        //     if (!proceedAction) return;

        //     this.isGenerating = true;
        //     this.status = 'processing';

        //     try {
        //         const result = await axios.post('/api/admin/users-creditors/qgc-generate-claim-pdfs');
        //         this.jobId = result.data.jobId;
        //         this.startPolling();
        //     } catch (error) {
        //         this.status = 'failed';
        //         this.$dialog.notify.error(this.$codes(error) || 'Erro ao iniciar a geração de PDFs', {
        //             position: 'top-right', timeout: 2000
        //         });
        //     } finally {
        //         this.isGenerating = false;
        //     }
        // },

        // async checkJobStatus() {
        //     try {
        //         const res = await axios.get(`/api/admin/users-creditors/qgc-check-pdf-job-status?jobId=${this.jobId}`)

        //         if (!res.data || typeof res.data !== 'object') {
        //             throw new Error('Resposta inválida ou vazia do servidor');
        //         }

        //         this.status = res.data.state === 'completed' ? 'completed' :
        //             res.data.state === 'failed' ? 'failed' : 'processing';

        //         if (this.status === 'processing' && res.data.progress) {
        //             this.progressText = `Processando: ${res.data.progress}`;
        //         }

        //         if (this.status === 'completed') {
        //             this.progressText = '';
        //             this.generatedFiles = res.data.files || [];
        //             this.$dialog.notify.info("Arquivos PDF gerados com sucesso!", {
        //                 position: "top-right", timeout: 2000
        //             });
        //             this.stopPolling();
        //         } else if (this.status === 'failed') {
        //             this.progressText = '';
        //             this.$dialog.notify.error(res.data.error || 'Falha ao gerar PDFs', {
        //                 position: 'top-right', timeout: 2000
        //             });
        //             this.stopPolling();
        //         }
        //     } catch (error) {
        //         this.status = 'failed';
        //         this.progressText = '';
        //         this.$dialog.notify.error('Erro ao verificar o status: ' + (error.message || 'Resposta inválida'), {
        //             position: 'top-right', timeout: 2000
        //         });
        //         this.stopPolling();
        //     }
        // },

        // startPolling() {
        //     this.pollingInterval = setInterval(() => {
        //         this.checkJobStatus();
        //     }, 5000);
        // },

        // stopPolling() {
        //     if (this.pollingInterval) {
        //         clearInterval(this.pollingInterval);
        //         this.pollingInterval = null;
        //     }
        // },

        // beforeDestroy() {
        //     this.stopPolling();
        // },
    },
};
</script>

<style lang="scss">
.excluded-record {
    opacity: 0.6;
    pointer-events: none;
    color: #aaa;
}

.icon-toolbar {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 6px 16px;
}

.icon-toolbar .v-badge .v-badge__badge {
    min-width: 15px !important;
    height: 15px !important;
    padding: 0 3px !important;
    font-size: 8px !important;
    line-height: 15px !important;
    top: -4px !important;
    right: -4px !important;
}
</style>
